// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__JkN-y","info":"Note_info__bn4eA","note":"Note_note__2kLMn","actions":"Note_actions__1SAzE"};